export const API = () => {
  let API_URL = "";
  process.env.NODE_ENV === "development"
    ? (API_URL = `https://io.mycheck.pl:8001`)
    : (API_URL = `https://admin.devzuro.link:8001`);
  return API_URL;
};
